import { RequestImmediateAttendanceParams } from '../scheduled-types'

export class RequestImmediateAttendanceMapper {
  static toPersistence(data: RequestImmediateAttendanceParams) {
    return {
      tipoProfissional: data.professionalType,
      encaixe: data.fitAttendance,
      idEspecialidade: data.specialtyId,
      prioridade: data?.priority ?? false,
    }
  }
}
